export { EMAIL_TEMPLATES } from '@shared/email/email.constants.js';

// For now added a fallback email address
// FUTURE: Remove the fallback and make sure that all reference areas handle undefined values
export const SUPPORT_EMAIL_ADDRESS = (import.meta.env.VITE_APP_SUPPORT_EMAIL || 'support@candor.org') as string;
